<!-- <div class="main-content"> -->
  <app-header />
  <div class="app-layout">
    <app-sidebar />
    <div class="app-content">
      <router-outlet />
      <div class="app-footer">
        <app-footer />
      </div>
    </div>
  </div>
<!-- </div> -->